import React, { Component, Fragment } from 'react';
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { Link } from 'react-router-dom';
import { DATE_TIME_FORMAT, PATHS, SUPPLIER } from '../../../../../constants/Define';
import { FormWrapperItem, ListComponent, StatusComponent, FilterDropdown } from '../../../common/component/Index';
import Modal from '../../../common/component/Modal';
import Ripple from '../../../common/component/Ripple';
import Dropdown from '../../../common/component/Dropdown';
import { FlagIcons } from '../../../common/component/TranslateButton';

import Supplier from '../../../../../models/Supplier';
import { Icon, Menu, Tooltip } from 'antd';
import { isEqual, find, toArray } from 'lodash';
import './SupplierList.less';
import EllipsisText from '../../../common/component/EllipsisText';

const defaultState = {

};

const ListCols = ['supplierName', 'code', 'address', 'email', 'phoneNumber', 'taxNumber', 'contractStatus', 'signedDate', 'contractEndDate', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Supplier());

export default class SupplierList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                supplierName: {
                    sorter: (i, k) => (i.supplierName || '').length - k.length,
                    fixed: 'left',
                    width: 220,
                    key: 'searchTerm',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                code: {
                    key: 'code',
                    fixed: 'left',
                    width: 100,
                },
                address: {
                    key: 'address',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                email: {
                    key: 'email',
                },
                phoneNumber: {
                    key: 'phoneNumber',
                },
                taxNumber: {
                    key: 'taxNumber',
                },
                contractStatus: {
                    align: 'center',
                    render: (id, record) => {
                        const status = find(toArray(SUPPLIER.CONTRACT.STATUS), item => item.id === id)
                        return !!status && <StatusComponent color={status.color}
                            label={this.props.t(`item.supplier.contract.status.${status.key}`)} />
                    },
                    // filters: toArray(SUPPLIER.CONTRACT.STATUS).map(item => ({ value: item.id, text: this.props.t(`item.supplier.contract.status.${item.key}`) })),
                    key: 'contractStatus',
                },
                signedDate: {
                    render: (text, record) => record.signedDate && record.signedDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    key: 'signedDate',
                },
                contractEndDate: {
                    render: (text, record) => record.contractEndDate && record.contractEndDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    key: 'contractEndDate',
                },
                translations: {
                    key: 'languageCode',
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    render() {
        const { t, suppliers, loading, pagination } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        const dataSource = suppliers.map(cate => { cate.children = undefined; return cate });
        return (
            <Wrapper className="mt-2 redeemtion-list">
                <ListComponent
                    tableKey="supplier-list"
                    scroll={{ x: 1500 }}
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(dataSource || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'supplier'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.defaultCurrent, pageSize: pagination.pageSize }}
                    onChange={this.props.onChange}
                    componentTableList={{}}
                />
            </Wrapper>
        );
    }

    renderEditComponent(item) {
        const { t, permissions } = this.props;
        const removeItem = () => {
            return this.props.onDeleteSupplier && this.props.onDeleteSupplier(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.supplier.title`)),
                content: item.supplierName,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permissions && permissions.allowUpdate &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.SUPPLIER.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permissions && permissions.allowDelete &&
                        <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

}

SupplierList.defaultProps = {
    suppliers: [],
    pagination: {},
    permissions: {},
    loading: false,
    onChange: (pagination, filters, sorter) => { },
    onDeleteSupplier: (item) => { },
}

